import DataTable from 'components/DataTable/DataTable'
import { UOMContract } from 'models'
import { useUOMsContext } from 'pages/UOMsPage/context/UOMsContext'
import nameof from 'utilities/nameof'

const fields = nameof<UOMContract>()

function SystemUOMLookupTable() {
    const {
        systemUOMs,
        loading,
        uomsTableHeaders,
        onUpdateDefaultUOM,
    } = useUOMsContext()

    return (
        <DataTable
            data={systemUOMs}
            headers={uomsTableHeaders}
            itemKey={fields.uomid}
            loading={loading}
            selectMode={false}
            onToggleSwitch={(_, uom) => onUpdateDefaultUOM(uom.uomid!)}
        />
    )
}

export default SystemUOMLookupTable
